<template>
  <div class="p-3 pt-4">
    <transition name="fade">
      <MenssageAlert :messages="messages" />
    </transition>
    <CRow class="mb-3">
      <CCol sm="6" v-for="contentType in contentTypesOptions" :key="contentType.id" class="text-gray-600 cardChannel">
        <CInputRadio
          name="target"
          type="radio"
          class="cardChannel__checkRadio"
          :class="{
            'cardChannel__checkRadio--active': selectedContentType == contentType.id,
          }"
          :id="contentType.id"
          :value="contentType.name"
          :checked="selectedContentType == contentType.id"
          @update:checked="selectContentType(contentType.id)"
          hidden
        />
        <div class="cardChannel__child" @click="selectContentType(contentType.id)">
          <label :for="contentType" class="d-flex justify-content-center align-items-center flex-column p-3 mb-0">
            <CIcon :name="contentType.icon" size="xl" class="mb-2" />
            <span class="font-weight-normal font-md text-center">{{ $t(`automation.content.${contentType.translationKey}.title`) }}</span>
          </label>
        </div>
      </CCol>
    </CRow>

    <AutomationSMSContentNew
      ref="new"
      v-if="selectedContentType == CONTENT_TYPES.NEW"
      @update-field="updateField"
      :senderSelectOptions="sendersList"
      :isLoadingSenders="isLoadingSenders"
      :customFieldsSelectOptions="customFieldsList"
      :isLoadingCustomFields="isLoadingCustomFields"
    />
    <AutomationSMSContentTemplate
      ref="template"
      v-if="selectedContentType == CONTENT_TYPES.TEMPLATE"
      @update-field="updateField"
      :senderSelectOptions="sendersList"
      :isLoadingSenders="isLoadingSenders"
      :templateSelectOptions="templateList"
      :isLoadingTemplates="isLoadingTemplates"
    />
  </div>
</template>

<script>
import vSelect from 'vue-select'
import services from '@/services.js'
import { getSchema } from '@/utils/audienceSchema'
import AutomationSMSContentNew from './AutomationSMSContentNew.vue'
import AutomationSMSContentTemplate from './AutomationSMSContentTemplate.vue'
import { getErrorMessage } from '@/utils/errorHandling.js'
import MenssageAlert from '@/components/MenssageAlert'
import { FIELD_TYPE } from '../constants'

const CONTENT_TYPES = {
  NEW: 1,
  TEMPLATE: 2,
}

export default {
  name: 'AutomationSMSContent',
  components: { vSelect, AutomationSMSContentNew, AutomationSMSContentTemplate, MenssageAlert },
  data() {
    return {
      messages: [],
      selectedContentType: undefined,
      CONTENT_TYPES: CONTENT_TYPES,
      contentTypesOptions: [
        { id: CONTENT_TYPES.NEW, name: 'new', translationKey: '001', icon: 'cilPencil' },
        { id: CONTENT_TYPES.TEMPLATE, name: 'template', translationKey: '002', icon: 'cilLayers' },
      ],
      sendersList: undefined,
      isLoadingSenders: false,
      customFieldsList: undefined,
      isLoadingCustomFields: false,
      templateList: undefined,
      isLoadingTemplates: false,
    }
  },
  mounted() {
    if (this.$store.state.automation.mainWorkflow.workflowJson.steps.values[0].data.templateId === null) this.selectedContentType = CONTENT_TYPES.NEW
    else if (this.$store.state.automation.mainWorkflow.workflowJson.steps.values[0].data.templateId) this.selectedContentType = CONTENT_TYPES.TEMPLATE

    this.loadSenders()
    this.loadCustomFields()
    this.loadSMSTemplates()
  },
  methods: {
    updateField(obj) {
      this.$emit('update-field', obj)
    },
    async loadSenders() {
      try {
        this.isLoadingSenders = true
        let organizationId = this.$route.params.organizationId

        const response = await services.getSendersByOrganizationUserId(organizationId)

        let list = response.data.data.map((elm) => {
          return { value: elm.senderId, label: elm.sender }
        })

        this.sendersList = list
        this.$refs.new.loadFields()
      } catch (error) {
        this.messages = [getErrorMessage(error?.response?.data)]
      } finally {
        this.isLoadingSenders = false
      }
    },
    async loadCustomFields() {
      try {
        this.isLoadingCustomFields = true
        const organizationId = this.$route.params.organizationId

        this.customFieldsList = await getSchema(organizationId)
      } catch (error) {
        this.messages = [getErrorMessage(error?.response?.data)]
      } finally {
        this.isLoadingCustomFields = false
      }
    },
    async loadSMSTemplates() {
      try {
        this.isLoadingTemplateList = true
        const organizationId = this.$route.params.organizationId
        services.getTemplateSMSOrganization(organizationId).then((res) => {
          let list = res.data.data.templates.map((elm) => {
            return {
              value: elm.smsTemplateId,
              label: elm.name,
              templateContent: elm.templateContent,
            }
          })
          this.templateList = list
        })
      } catch (error) {
        this.messages = [getErrorMessage(error?.response?.data)]
      } finally {
        this.isLoadingTemplateList = false
      }
    },
    selectContentType(contentTypeId) {
      this.selectedContentType = contentTypeId
      let obj = {
        property: 'templateId',
        value: undefined,
        type: FIELD_TYPE.STEP,
      }
      if (this.selectedContentType == CONTENT_TYPES.NEW) {
        obj.value = null
      } else {
        obj.value = '00000000-0000-0000-0000-000000000000'
      }

      this.$store.commit('automation/SET_VALIDATION_CONTENT', false)

      let senderId = {
        property: 'senderId',
        value: null,
        type: FIELD_TYPE.STEP,
      }
      let senderName = {
        property: 'senderName',
        value: null,
        type: FIELD_TYPE.STEP,
      }
      let text = {
        property: 'text',
        value: null,
        type: FIELD_TYPE.STEP,
      }
      this.updateField(obj)
      this.updateField(senderId)
      this.updateField(senderName)
      this.updateField(text)
    },
  },
}
</script>
